// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"4ecc3097","660":"85f09e98"}[chunkId] + ".chunk.css";
};